import { createStyles } from "@mantine/emotion";

import { rooterMediaQuery } from "_styles/theme/mediaQuery";

export default createStyles ( theme => ( {
	tabsContainer: {
		width: "45%",

		[rooterMediaQuery.mobileAndTablet]: {
			width: "100%"
		}
	},
	contentContainer: {
		margin: "2.5rem 2rem",

		[rooterMediaQuery.mobile]: {
			margin: "unset"
		}
	}
} ), { name: "profilePage" } );

